import React from 'react';

export default function TaglineBanner({ children = 'SERIOUS TRAINING — SAFE OPERATORS — NO COMPROMISE' }) {
  return (
    <section
      className="relative bg-[#060D9C] text-white overflow-hidden"
      data-testid="tagline-banner"
    >
      <div className="hi-vis-stripe h-1.5" aria-hidden="true" />
      <div className="nft-container py-6 lg:py-8 text-center">
        <h2 className="font-display font-extrabold uppercase text-2xl sm:text-3xl lg:text-4xl tracking-wide">
          {children}
        </h2>
      </div>
      <div className="hi-vis-stripe h-1.5" aria-hidden="true" />
    </section>
  );
}
